/**
 * Testimonial preview
 */

var AwesomeTestimonial = function (){
    'use strict';

    var $ = jQuery; // enable jQuery
    var self = this;
    var form = new AwesomeForm();

    // two way data bindings for edit group form
    self.bind_form = function(){
        var dfd = $.Deferred();

        // Upload testimonial avatar via built-in Wordpress media library

        var bind_photo_upload = form.bind_photo_upload.bind(this);
        bind_photo_upload('testimonial_thumbnail_id', 'custom_fields.thumbnail_id');



        $(document).on('input', 'input[name="testimonial_rating"]', function (e) {
            var value = $(this).val();

            value = value.replace(/\D+/g, '');
            value = parseInt(value) > 100 ? 100 : value;
            //model.set('custom_fields.rating', value);
        });

        dfd.resolve();
        return dfd;
    };


    // destroy preview
    self.destroy = function(){
        $('.panel-skills').off('click', '[data-action="add-skill"]');
        $('.skills-list').off('click', '[data-action="save-skill"]');
        $('.skills-list').off('click', '[data-action="edit-skill"]');
        $('.skills-list').off('click', '[data-action="delete-skill"]');
        $('.skills-list').off('click', '[data-action="cancel-skill-edit"]');
        $(document).off('click', '[data-action="upload_photo"]');
    };

    // init preview
    self.init = function(){
        self.bind_form();
        var form = new AwesomeForm();
        form.init(model);

        window.testimonial_form_view = new TestimonialForm({
            model: window.model
        });
        if(model.get('id')){
            testimonial_form_view.setElement($('#testimonial-edit-wrap', aet_panel));
        }else{
            testimonial_form_view.setElement($('#testimonial-add-wrap', aet_panel));
        }
        testimonial_form_view.render();
    };
};